import React from 'react';
import LedgerDatasetTableShell, { LedgerDatasetTableShellProps } from '../shared/LedgerDatasetTableShell';

type APVendorsTableProps = Omit<LedgerDatasetTableShellProps, 'view' | 'accountingSource'>;

const APVendorsTable: React.FC<APVendorsTableProps> = (props) => (
    <LedgerDatasetTableShell {...props} view="ar" accountingSource="ap_vendors" />
);

export default APVendorsTable;
